import * as ACTIONTYPE from '../constants/actiontypes'

export default function (state = false, action) {
  switch (action.type) {
    case ACTIONTYPE.TOGGLE_TEXT_SETTINGS:
      return action.isVisible;
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/store/reducers/ShowTextSettingsReducer.js